

















interface Props {
  title: PropOptions;
  content: PropOptions;
  clickable: PropOptions;
}

import Vue, { PropOptions } from 'vue';
export default Vue.extend({
  name: 'HMStatCard',
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    content: {
      required: false,
    },
    clickable: {
      type: Boolean,
    },
  } as Props,
});
